import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useGetSsoSettings = (enabled = true) => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.SsoSettings], () => api.base.get('/api/settings/Sso').then(res => res.data), {
        enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
